import { checkProcessDivergences, getTheoreticalMatchFromCartHistory } from "./dior-check-errors";

export const SCAN_STATE_STANDBY = 0;
export const SCAN_STATE_CURRENT = 1;
export const SCAN_STATE_WAITING = 2;
export const SCAN_STATE_OTHER = 3;
export const SCAN_STATE_GA170 = 4;
export const SCAN_STATE_GA600 = 5;
export const SCAN_STATE_GA112 = 6;
export const SCAN_STATE_CATAPHORESIS = 7;

// TODO Move into a database
export const POOLS_LINE_1 = [
  { name: 'RACKING', skip: true }, // 0 - null
  { name: 'DESENGORDURANTE', skip: true }, // 1 - null

  { name: 'DESENGORDURANTE' }, // 2 - 0
  { name: '3 AGUAS', sub_pools: 3, screen_position: 0 }, // 3 - 1 2 3
  { name: 'ELECTROLITICO' }, // 4 - 4
  { name: '3 AGUAS', sub_pools: 3 }, // 5 - 5 6 7
  { name: 'ATIVADOR' }, // 6 - 8
  { name: '2 AGUAS', sub_pools: 2 }, // 7 - 9 10
  { name: 'COBRE ALCALINO' }, // 8 - 11
  { name: '3 AGUAS', sub_pools: 3 }, // 9 - 12 13 14
  { name: 'COBRE ACIDO' }, // 10 - 15
  { name: 'COBRE ACIDO', duplicate_of: 10, screen_position: 50 }, // 10 - 16
  { name: '3 AGUAS', sub_pools: 3 }, // 11 - 17 18 19
  { name: 'BRONZE AMARELO' }, // 12 - 20
  { name: 'BRONZE AMARELO', duplicate_of: 12 }, // 12 - 21
  { name: '3 AGUAS', sub_pools: 3 }, // 13 - 22 23 24
  { name: 'ELECTROLITICO' }, // 14 - 25
  { name: '3 AGUAS', sub_pools: 3 }, // 15 - 26 27 28
  { name: 'ATIVADOR' }, // 16 - 29
  { name: '2 AGUAS', sub_pools: 2 }, // 17 - 30 31
  { name: 'TANQUE VAZIO' }, // 18 - 32
  { name: '3 AGUAS VAZIO', sub_pools: 3 }, // 19 - 33 34 35
  { name: 'OURO COR 218' }, // 20 - 36
  { name: 'OURO CAMADA' }, // 21 - 37
  { name: '3 AGUAS', sub_pools: 3 }, // 22 - 38 39 40
];

export const POOLS_LINE_2 = [
  { name: 'OURO 112' }, // 23 - 41
  { name: '3 AGUAS', sub_pools: 3 }, // 24 - 42 43 44
  { name: 'OURO COR 218' }, // 25 - 45
  { name: '3 AGUAS', sub_pools: 3 }, // 26 - 46 47 48
  { name: 'PALADIO' }, // 27 - 49
  { name: '3 AGUAS', sub_pools: 3 }, // 28 - 50 51 52
  { name: 'TANQUE VAZIO' }, // 29 - 53
  { name: '3 AGUAS VAZIO', sub_pools: 3, screen_position: 64 }, // 30 - 54 55 56
  { name: 'RODIO' }, // 31 - 57
  { name: '3 AGUAS', sub_pools: 3 }, // 32 - 58 59 60
  { name: 'TANQUE VAZIO' }, // 33 - 61
  { name: '3 AGUAS VAZIO', sub_pools: 3 }, // 34 - 62 63 64
  { name: 'COBRE ACIDO' }, // 35 - 65
  { name: '3 AGUAS', sub_pools: 3 }, // 36 - 66 67 68
  { name: 'CATAFORESE' }, // 37 - 69
  { name: 'PRE-LACA', sub_pools: 1 }, // 38 - 70
  { name: 'POS-LACA', sub_pools: 1 }, // 39 - 71
  { name: 'AGUAS', sub_pools: 1 }, // 40 - 72
  { name: 'ULTRASSONS' }, // 41 - 73
  { name: 'AGUA QUENTE' }, // 42 - 74
  { name: 'PISTOLA DE AR', sub_pools: 1, skip: true }, // 43 - null
  { name: 'FORNO 1', skip: true }, // 44 - null
  { name: 'FORNO 2', skip: true }, // 45 - null
  { name: 'UNRACKING', skip: true }, // 46 - null
];

export const ALL_POOLS = [...POOLS_LINE_1, ...POOLS_LINE_2];

export const getSchemeId = (realIndex) => {
  if (realIndex === null) return 2; // First pool on the line

  realIndex = parseInt(realIndex);
  realIndex += 2;

  if (isNaN(realIndex) || realIndex < 0) return null;

  let currentRealIndex = 0;

  for (let schemeIndex = 0; schemeIndex < ALL_POOLS.length; schemeIndex++) {
    const entry = ALL_POOLS[schemeIndex];
    const subPools = entry.sub_pools ?? 1;

    const start = currentRealIndex;
    const end = currentRealIndex + subPools - 1;

    if (realIndex >= start && realIndex <= end) {
      if (entry.duplicate_of != null) {
        return entry.duplicate_of;
      }

      let duplicateCountBefore = 0;

      for (let i = 0; i < schemeIndex; i++) {
        if (ALL_POOLS[i]?.duplicate_of != null) {
          duplicateCountBefore += 1;
        }
      }

      return schemeIndex - duplicateCountBefore;
    }

    currentRealIndex += subPools;
  }

  return null;
};

export const getTechnicalSchemeId = (schemeId) => {
  schemeId = parseInt(schemeId);

  if (isNaN(schemeId)) return null;

  let duplicates = 0;

  for (let i = 0; i < ALL_POOLS.length; i++) {
    const entry = ALL_POOLS[i];
    const currentSchemeId = entry.duplicate_of ?? (i - duplicates);

    if (currentSchemeId === schemeId) return i;
    if (entry.duplicate_of != null) duplicates++;
  }

  return null;
};

export const getSchemeIdFromTechnicalSchemeId = (technicalSchemeId) => {
  technicalSchemeId = parseInt(technicalSchemeId);

  if (isNaN(technicalSchemeId) || technicalSchemeId < 0) return null;

  let duplicates = 0;

  for (let i = 0; i <= technicalSchemeId; i++) {
    const entry = ALL_POOLS[i];

    if (i === technicalSchemeId) {
      return entry.duplicate_of ?? (i - duplicates);
    }

    if (entry.duplicate_of != null) {
      duplicates++;
    }
  }

  return null;
};

/*
 - realId = ID used by the engine
 - schemeId = ID displayed on the customer plans
 - technicalSchemeId = technical scheme ID (index in the list of pools)
 */
export const findPoolBySchemeId = (schemeId) => {
  const technicalSchemeId = getTechnicalSchemeId(schemeId);
  return findPoolByTechnicalSchemeId(technicalSchemeId);
};

export const findPoolByTechnicalSchemeId = (technicalSchemeId) => {
  if (technicalSchemeId == null) return null;
  return ALL_POOLS[technicalSchemeId];
};

export const findPoolByRealId = (realId) => {
  const schemeId = getSchemeId(realId);
  return findPoolBySchemeId(schemeId);
};

export const getCartColor = () => {
  // TODO Depends on process name
  return '#fff8a6';
};

/**
 * Returns true if the cart is completed according to the theoretical recipe.
 * Conditions:
 * 1) The last history step matches the last theoretical step
 * 2) This last history step is done
 *
 * @param {Array} cartHistory - List of real steps for a cart.
 * @param {Array} theoretical - Theoretical process definition.
 * @returns {boolean}
 */
export const isCartFinished = (cartHistory, theoretical) => {
  if (!cartHistory || cartHistory.length === 0) return false;
  if (!theoretical || theoretical.length === 0) return false;

  const lastStep = cartHistory[cartHistory.length - 1];

  const { theoreticalStepIndex } = getTheoreticalMatchFromCartHistory(cartHistory, theoretical);

  if (theoreticalStepIndex == null) return false;

  const isLastTheoreticalStep = theoreticalStepIndex === theoretical.length - 1;
  const isDone = lastStep.done === 1 || lastStep.done === true;

  return isLastTheoreticalStep && isDone;
};


export const sortKanbanCarts = (currentCarts, processes) => {
  return currentCarts
    .map(cart => {
      const cartHistorySchemeId = cart.history.map((step) => ({...step, pool_id: getSchemeId(step.pool_id)}));

      const lastStep = (() => {
        if (!cart?.history || cart.history.length === 0) return null;
        return cart.history[cart.history.length - 1];
      })();

      let process = processes.find((process) => process.name === cart.rack_type)?.pattern_data?.[0]?.json;
      if (!process) process = [];

      const { theoreticalStep } = getTheoreticalMatchFromCartHistory(cartHistorySchemeId, process);
      const theoreticalDuration = theoreticalStep?.duration_min ?? 0;

      const cartPoolRealId = lastStep?.pool_id ?? null;
      const cartValue = lastStep?.value ?? null;
      const minDurationOver = cartValue > theoreticalDuration;

      const cartPoolSchemeId = getSchemeId(cartPoolRealId);
      const { steps_error: cartErrors } = checkProcessDivergences(process, cartHistorySchemeId);
      const isCurrentPoolError = cartErrors.find((error) => error.details.pool_id === cartPoolSchemeId) !== undefined;

      return {...cart, rank: isCurrentPoolError ? 0 : minDurationOver ? 1 : 2 }
    })
    .sort((a, b) => a.rank - b.rank);
};

export const convertToSchemeHistory = (history) => history.map((step) => ({ ...step, pool_id: getSchemeId(step.pool_id) }));


/* INFLUXDB REQUESTS */

export const getRacksTypesCount = () => {
  return 'from(bucket: "engine")\n' +
    '  |> range(start: v.timeRangeStart, stop: v.timeRangeStop)\n' +
    '  |> filter(fn: (r) => r["_measurement"] == "racks")\n' +
    '  |> filter(fn: (r) => r["_field"] == "value")\n' +
    '  |> filter(fn: (r) => r["client_id"] == "dior_0")\n' +
    '  |> group(columns: ["type"])\n' +
    '  |> count()';
};